import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// 自定义主题引入
import '@/static/style/theme/index.css'
// import VueParticles from 'vue-particles';
import http from '@/http/http';
import nw from '@/utils/nw'
import utils from '@/utils/utils'
import printing from '@/utils/printing'

Vue.config.productionTip = false

Vue.use(ElementUI)
// Vue.use(VueParticles)

Vue.prototype.$http = http
Vue.prototype.$nw = nw
Vue.prototype.$utils = utils
Vue.prototype.$printing = printing

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
